import { useState, useEffect } from 'react';

import { List } from '../../domain';
import { ListSkeletonRow } from './ListSkeletonRow';

interface SkeletonRowsProps {
  lists: List[];
  isLoading: boolean;
}

export const SkeletonRows = ({ lists, isLoading }: SkeletonRowsProps) => {
  const [skeletonCount, setSkeletonCount] = useState(lists.length);
  const DEFAULT_COUNT = 5;
  const amount = skeletonCount || DEFAULT_COUNT;

  useEffect(() => {
    if (!isLoading) {
      setSkeletonCount(lists.length);
    }
  }, [lists, isLoading]);

  return (
    <>
      {new Array(amount).fill(null).map((_, i) => (
        <ListSkeletonRow key={`list-table-skeleton-${i}`} />
      ))}
    </>
  );
};
